import { createFileRoute } from '@tanstack/react-router'
import { DhbPage } from 'pages/dhb/DhbPage'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import {
  DEFAULT_DHB_TAB,
  dhbSearchParams,
  type DhbTab,
} from 'routes/dhb/-searchParams'

const RouteComponent = () => {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <DhbPage
      orgID={search[SEARCH_PARAM_ORG_ID]}
      siteID={search[SEARCH_PARAM_SITE_ID]}
      tab={search.tab ?? DEFAULT_DHB_TAB}
      step={search.step}
      importId={search.importId}
      onTabChange={(tab: DhbTab) =>
        // `replace` keeps tab flipping out of the back-button history.
        void navigate({ search: (prev) => ({ ...prev, tab }), replace: true })
      }
    />
  )
}

export const Route = createFileRoute('/dhb/')({
  component: RouteComponent,
  validateSearch: dhbSearchParams,
  staticData: {
    title: 'Data History Book',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})
